export var AssigneeType;
(function (AssigneeType) {
    AssigneeType["Contact"] = "contact";
    AssigneeType["Group"] = "access_group";
})(AssigneeType || (AssigneeType = {}));
